import axios from 'taro-axios'; //eslint-disable-line
import Taro from '@tarojs/taro';
import { createAxiosInstance } from '&/utils/$axiosCreater';

let offlineToastExpiry = 0;

function messageFn(res) {
    const { content, duration = 2, code, key } = res;
    const messageContent = key === 'offline' ? '网络异常，请稍后再试' : content;
   
    if (key === 'offline') {
        const toastDurationMs = duration * 1e3;
        const now = Date.now();

        if (now >= offlineToastExpiry) {
            offlineToastExpiry = now + toastDurationMs;
            // Use toast to avoid stacking multiple offline notifications during connectivity loss.
            Taro.showToast({
                title: messageContent,
                duration: toastDurationMs,
                icon: 'none',
            });
        }

        return;
    }

     Taro.showToast({
        title: content,
        icon: 'none',
        duration: duration * 1e3,
    });

    if (code === 401) {
        if (window.externalDispatchFun) {
            window.externalDispatchFun('HDC', 'tokenInvalid', '');
        } else {
            window.location.reload();
        }
    }
}

const AXIOS = createAxiosInstance(axios, APP_BASE_URL, messageFn);

AXIOS.interceptors.response.use(
    response => Promise.resolve(response),
    error => {
        if (error.code === 10003) {
            Taro.redirectTo({ url: 'pages/home/index' });
        }
        return Promise.reject(error);
    }
);

export default AXIOS;
export { getConfirmation } from '&/utils/$axiosCreater';
